import { Screenmode } from './screenmode'

export class ElementGroup3 {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        elementGroup: '.element-group--3',
        orangeTeaser: '.element-group__orange-teaser',
        violetTeaser: '.element-group__violet-teaser'
      }
    },
    settings)
  }

  init () {
    const that = this
    let resizeTimer

    setTimeout(function () {
      that.setBoxHeight()
    }, 500)

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          that.setBoxHeight()
        }, 250)
      })
  }

  setBoxHeight () {
    const that = this
    const currentBreakpoint = new Screenmode().getCurrentBreakpoint()
    const orangeTeaser = $(that.options.selectors.orangeTeaser)
    const violetTeaser = $(that.options.selectors.violetTeaser)

    orangeTeaser
      .css('min-height', '')

    violetTeaser
      .css('min-height', '')

    if (currentBreakpoint === 'lg' || currentBreakpoint === 'xl') {
      orangeTeaser
        .each(function () {
          const currentOrangeTeaser = $(this)
          const elementGroup = currentOrangeTeaser.closest(that.options.selectors.elementGroup)
          const violetTeaser = elementGroup.find(that.options.selectors.violetTeaser)

          if (violetTeaser.length > 0) {
            if (violetTeaser.height() > currentOrangeTeaser.height()) {
              currentOrangeTeaser.css('min-height', violetTeaser.outerHeight() + 'px')
            } else {
              violetTeaser.css('min-height', currentOrangeTeaser.outerHeight() + 'px')
            }
          }
        })
    }
  }
}

export default ElementGroup3
